import React from "react";

const FAQEn = () => {
  const sections = [
    {
      title: "Products and Services",
      questions: [
        [
          "Are all products/services on Ananas Solutions verified?",
          "Yes. Only authorized and validated companies are allowed to sell their products and services on the platform.",
        ],
      ],
    },
    {
      title: "User Account",
      questions: [
        [
          "How do I create an account?",
          "Click on 'Login', then 'Create an account'. You can either fill in the registration form or sign in with Google and validate the code sent by email.",
        ],
        [
          "How can I reset my password?",
          "This feature is not yet available, but it will be coming soon (planned).",
        ],
        [
          "Can I change my email address?",
          "To update your email address, please contact us at information@ananassolutions.com.",
        ],
        [
          "How do I delete my account?",
          "You can request deletion by contacting us at privacy@ananassolutions.com.",
        ],
      ],
    },
    {
      title: "Representatives and Partners",
      questions: [
        [
          "How can I become a representative?",
          "Please contact a representative in your region via ananassolutions.ca/find-a-representative and submit your request.",
        ],
      ],
    },
    {
      title: "Payments and Subscriptions",
      questions: [
        [
          "What subscription plans do you offer?",
          "We offer business subscriptions that include services such as photography, video production, editing, and advertising campaigns.",
        ],
        [
          "Can I pay in multiple installments?",
          "No. Each subscription is valid for a specific period (3 months, 6 months, or 1 year) and includes the services linked to that subscription.",
        ],
      ],
    },
    {
      title: "Shipping and Returns",
      questions: [
        [
          "Which carriers do you use?",
          "Deliveries are handled by the suppliers themselves. Each company chooses its own carrier for shipments.",
        ],
        [
          "How are shipping fees calculated?",
          "Shipping costs are calculated separately by each supplier/warehouse. Ananas Solutions does not manage shipping directly.",
        ],
        [
          "Do you offer international shipping?",
          "This depends on the supplier’s chosen carrier.",
        ],
        [
          "How can I return a product or report a problem?",
          "For returns, please contact the supplier directly. If there is a problem with a product or service, contact us first at information@ananassolutions.com.",
        ],
      ],
    },
    {
      title: "Personal Data and Law 25",
      questions: [
        [
          "Who is responsible for personal data protection?",
          "The Privacy Officer is our Chief Technology Officer (CTO). You can reach them at privacy@ananassolutions.com.",
        ],
        [
          "Where is my data hosted?",
          "We make every effort to store your data in Canada and in Quebec whenever possible.",
        ],
        [
          "How can I withdraw my marketing consent?",
          "You can unsubscribe from emails using the link included in each message. Ads displayed on the site cannot be removed, but we strive to keep them as non-intrusive as possible.",
        ],
      ],
    },
    {
      title: "Legal",
      questions: [
        [
          "What is the legal entity behind Ananas Solutions?",
          "Ananas Solutions is a product of Ananas Acti-Solutions Inc.",
        ],
        [
          "Which jurisdiction applies in case of dispute?",
          "Disputes will be handled on a case-by-case basis, but always within the province of Quebec.",
        ],
        [
          "Can the Terms of Use change?",
          "Yes, they may be updated at any time. A notice will be posted on the site when major updates occur.",
        ],
        [
          "Does Ananas Solutions guarantee third-party services?",
          "We cannot guarantee the quality of third-party companies. However, we do everything possible to satisfy our clients. Companies that do not comply with our Terms of Use or receive too many complaints may be removed from the platform after review by our team.",
        ],
      ],
    },
    {
      title: "Support and Assistance",
      questions: [
        [
          "How can I contact support?",
          "You can reach us at information@ananassolutions.com or by phone at 450-700-1721. If no agent is available, please leave a message or contact us by email.",
        ],
        [
          "Do you offer bilingual support?",
          "Yes, we provide support in both English and French.",
        ],
        [
          "Can I submit a request via the website?",
          "Yes, you can use the form available at ananassolutions.ca/contact.",
        ],
        [
          "Do you provide tutorials?",
          "Not at the moment, but they will be added soon.",
        ],
      ],
    },
  ];

  return (
    <div className="container mx-auto px-4 py-8 text-onWhite">
      <h1 className="text-3xl font-bold text-center mb-8">
        FAQ – Frequently Asked Questions
      </h1>
      {sections.map((section, sIdx) => (
        <div key={sIdx} className="mb-8">
          <h2 className="text-xl font-semibold mb-4">{section.title}</h2>
          <div className="join join-vertical w-full">
            {section.questions.map(([q, a], idx) => (
              <div
                key={idx}
                className="collapse collapse-arrow join-item border border-[#3a3a3a]/20"
              >
                <input type="checkbox" />
                <div className="collapse-title text-lg font-medium">{q}</div>
                <div className="collapse-content">
                  <p>{a}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default FAQEn;
